import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getTargets() {
  return axios.get(API_URL+'/v1/changelog/listTarget')
}
export function getTargetsbyTenant(tenant:any) {
  return axios.get(API_URL+'/v1/changelog/listTarget?tenantId='+tenant)
}

export function postUserLogs(Id:any,body:any) {
    return axios.post(API_URL+'/v1/changelog/'+Id,body)
}
export function postUserLogsTenant(Id:any,tenant:any,body:any) {
    return axios.post(API_URL+'/v1/changelog/'+Id+'?tenantId='+tenant,body)
}